import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { TOKEN_KEY } from '../../lib/api/auth';

export const ProtectedRoute: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("[ProtectedRoute] Checking authentication...");
    console.log('[ProtectedRoute] Chemin actuel:', location.pathname);

    const checkAuth = () => {
      try {
        // Vérifier d'abord le token
        const token = localStorage.getItem(TOKEN_KEY);
        console.log('[ProtectedRoute] Token trouvé dans localStorage:', token ? 'oui' : 'non');

        // Vérifier également les données utilisateur
        const userData = localStorage.getItem('user');
        console.log('[ProtectedRoute] Données utilisateur trouvées:', userData ? 'oui' : 'non');

        if (!token) {
          console.log('[ProtectedRoute] No token found, redirecting to /login');
          return false;
        }

        // Vérifier si le token est expiré (si nécessaire)
        // const tokenExpiry = getTokenExpiry(token);
        // if (tokenExpiry && tokenExpiry < Date.now() / 1000) {
        //   console.log('[ProtectedRoute] Token expiré');
        //   return false;
        // }

        console.log('[ProtectedRoute] Utilisateur authentifié');
        return true;
      } catch (error) {
        console.error(
          "[ProtectedRoute] Error during authentication verification:",
          error
        );
        return false;
      }
    };

    const authStatus = checkAuth();
    console.log(
      "[ProtectedRoute] Statut d'authentification:",
      authStatus ? 'authentifié' : 'non authentifié'
    );

    if (!authStatus) {
      console.log(`[ProtectedRoute] Redirection vers /login depuis ${location.pathname}`);
      navigate('/login', {
        replace: true,
        state: { from: location.pathname }, // Pour rediriger vers la page demandée après connexion
      });
    }

    setIsAuthenticated(authStatus);
    setIsLoading(false);
  }, [navigate, location]);

  if (isLoading || isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // La redirection est gérée dans le useEffect
    return null;
  }

  // Si authentifié, afficher le contenu protégé
  console.log('[ProtectedRoute] Affichage du contenu protégé');
  return <Outlet />;
};

